import api from './api';

export const getSettings = async () => {
  try {
    // En producción o desarrollo sin backend, usa datos mock
    if (process.env.NODE_ENV === 'production' || process.env.REACT_APP_USE_MOCK === 'true') {
      console.log('Using mock settings data');
      return getMockSettings();
    }
    
    const response = await api.get('/settings');
    return response.data;
  } catch (error) {
    console.error('Error en getSettings:', error);
    // Si hay un error, devuelve datos mock en lugar de fallar
    return getMockSettings();
  }
};

export const updateSettings = async (settingsData) => {
  try {
    const response = await api.put('/settings', settingsData);
    return response.data;
  } catch (error) {
    console.error('Error en updateSettings:', error);
    throw error;
  }
};

// Mock para desarrollo/testing
export const getMockSettings = () => {
  return {
    businessName: 'José Tapia',
    businessPhone: '1126789087',
    businessAddress: 'Sucre 1563',
    businessLocation: {
      latitude: -34.6037,
      longitude: -58.3816
    },
    businessHours: 'Atendemos de Lunes a viernes de 9 a 18h.',
    welcomeMessage: '¡Hola hola! 👋 Soy el asistente de José Trainer 💪\n¡Gracias por escribirnos! 👏 Guardá este contacto así podés:\n📋 Consultar tus rutinas\n📅 Agendar seguimientos con José\n💬 Y no te olvides de mandarnos novedades desde la sección de Notificaciones para que te podamos hacer un buen seguimiento 📊\n¡Estamos para acompañarte en cada paso! 🔥👟'
  };
};